const baseNotificationConfig = {};

class Notifier {
  constructor() {}

  init() {
    if (!("Notification" in window)) {
      alert("This browser does not support desktop notification");
    }
  }

  call(message, config) {
    this.notificationConfig = Object.assign(
      {},
      baseNotificationConfig,
      config || {}
    );
    if (Notification.permission === "granted") {
      this.createNotification(message);
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then(function(permission) {
        if (permission === "granted") {
          this.createNotification(message);
        }
      });
    }
  }

  createNotification(message) {
    this.notification = new Notification(message, this.notificationConfig);
    console.log(
      "Notification created",
      message,
      this.notificationConfig,
      this.notification
    );
  }
}

export default new Notifier();
